import React from 'react'
import { Box, Link, Typography } from 'transfix-ui/core'
import { makeStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui/theme/colors'
import { getLoadId } from 'apps/fleet-planner/utils/trailers'
import { LaneArrowIcon, LocationPinIcon, CalendarIcon } from 'transfix-icons'
import { Card } from 'transfix-ui'
import { DISPLAY } from 'constants/display'

const useStyles = makeStyles(theme => ({
  card: {
    marginTop: 15,
  },
  loadId: {
    color: brandColors.skyBlue6,
  },
  loadLocation: {
    fontWeight: 500,
  },
  locationDetail: {
    display: 'grid',
    gridTemplateColumns: '25px auto',
    alignItems: 'center',
    marginTop: theme.spacing(2),
  },
}))

export interface ICurrentLoadCardProps {
  currentDatetime?: string
  loadId?: string
  shipmentId?: string
  locationDetails?: string
  pickupLoadLocation?: string
  deliveryLoadLocation?: string
  pickupTrailerType?: string
  deliveryTrailerType?: string
  title?: string
}

const CurrentLoadCard = ({
  currentDatetime,
  deliveryLoadLocation = DISPLAY.empty,
  deliveryTrailerType = DISPLAY.empty,
  loadId = DISPLAY.empty,
  locationDetails = DISPLAY.empty,
  pickupLoadLocation = DISPLAY.empty,
  pickupTrailerType = DISPLAY.empty,
  title = 'Current Load',
  shipmentId = DISPLAY.empty,
}: ICurrentLoadCardProps) => {
  const classes = useStyles()

  return (
    <Card className={classes.card} title={title}>
      <Box display='flex' flexDirection='column'>
        <Link target='_blank' rel='noopener noreferrer' href={`${__ROOT__}/fms/loads/${loadId}`}>
          {getLoadId(shipmentId)}
        </Link>
        <Box display='flex' alignItems='center' marginBottom={1}>
          <Box marginRight={2} display='flex' flexDirection='column'>
            <Typography variant='h3' className={classes.loadLocation}>
              {pickupLoadLocation}
            </Typography>
            <Typography variant='body2' color='textSecondary'>
              {pickupTrailerType}
            </Typography>
          </Box>
          <LaneArrowIcon color='black' size='large' />
          <Box marginLeft={2} display='flex' flexDirection='column'>
            <Typography variant='h3' className={classes.loadLocation}>
              {deliveryLoadLocation}
            </Typography>
            <Typography variant='body2' color='textSecondary'>
              {deliveryTrailerType}
            </Typography>
          </Box>
        </Box>
        <Box className={classes.locationDetail}>
          <LocationPinIcon color='coolGray8' size='large' />
          <Typography variant='body2'>{locationDetails}</Typography>
        </Box>
        {currentDatetime && (
          <Box className={classes.locationDetail}>
            <CalendarIcon color='coolGray8' size='large' />
            <Typography variant='body2'>{currentDatetime}</Typography>
          </Box>
        )}
      </Box>
    </Card>
  )
}

export default CurrentLoadCard
